module.exports = __webpack_public_path__ + "img/47-21-plan.a3c96db8.jpg";